// extracted by mini-css-extract-plugin
module.exports = {"gutters":"ServerErrorPage_gutters__UjMTK","text":"ServerErrorPage_text__t5Hoa","image":"ServerErrorPage_image__REKRH"};